"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditScoreBox = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const value_thermometer_1 = require("../value-thermometer");
const scoring_model_1 = require("../../utils/scoring-model");
const Chevron = styled_components_1.default.div.withConfig({ displayName: "reports-Chevron", componentId: "reports-nx2p61" }) `
  width: 12px;
  height: 12px;
  border-top: 2px solid ${base_react_components_1.theme.neutral400};
  border-left: 2px solid ${base_react_components_1.theme.neutral400};
  transform: rotate(135deg);
`;
const ScoreValueContainer = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreValueContainer", componentId: "reports-xjf4zt" }) `
  display: flex;
  justify-content: flex-start;

  @supports not (display: grid) {
    & > ${base_react_components_1.Header} {
      padding-left: 8px;
    }
  }
`;
const ScoreThermometerSection = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreThermometerSection", componentId: "reports-ohk4t1" }) `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > ${ScoreValueContainer} {
    margin-right: 8px;
  }
`;
const CreditScoreBox = ({ 
/** the shorthand name for the credit bureaus */
bureau, reportableType, 
/** credit score */
score = 1, 
/** displays a chevron */
hasLink = false, }) => {
    const { maxPoor, maxFair, maxGood, minScore } = (0, scoring_model_1.getScoringRating)(bureau, reportableType);
    return (react_1.default.createElement(ScoreThermometerSection, { "data-testid": `credit-scores:credit-score-row:${bureau}-score-thermometer` },
        react_1.default.createElement(ScoreValueContainer, { "data-heap-redact-text": "true", className: "js-private" },
            react_1.default.createElement(value_thermometer_1.ScoreThermometer, { "data-testid": "credit-score-thermometer", score: score === 'No Score' ? undefined : score, maxPoor: maxPoor, maxFair: maxFair, maxGood: maxGood, minScore: minScore })),
        hasLink && react_1.default.createElement(Chevron, null)));
};
exports.CreditScoreBox = CreditScoreBox;
exports.default = (0, styled_components_1.default)(exports.CreditScoreBox).withConfig({ componentId: "reports-qh5jt2" }) ``;
//# sourceMappingURL=credit-score-box.js.map